module.exports = __webpack_public_path__ + "img/eu.254f746e.png";